/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsnet1Inputs */

const en_earningsnet1 = /** @type {(inputs: Earningsnet1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your earnings`)
};

const de_earningsnet1 = /** @type {(inputs: Earningsnet1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Einnahmen`)
};

/**
* | output |
* | --- |
* | "Your earnings" |
*
* @param {Earningsnet1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsnet1 = /** @type {((inputs?: Earningsnet1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsnet1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsnet1(inputs)
	return de_earningsnet1(inputs)
});
export { earningsnet1 as "earningsNet" }